import { ErrorHandler, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { ToastService } from '../services/toast.service';
import { UnknowErrorHandleRequest } from '../models/unknow-error-handle-request';
import { ErrorHandlerService } from '../services/error-handler.service';
import { UnknowErrorlog } from 'server/entity/unknow-errorlog';
import { SessionServiceService } from '../services/session-service.service';
import { isNullOrEmpty } from '../utils/common-functions';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  uuid: any;

  constructor(
    private logger: NGXLogger,
    private toastService: ToastService,
    private translateService: TranslateService,
    private errorHandlerService: ErrorHandlerService,
    private sessionServiceService: SessionServiceService
  ) {}

  async handleError(error: any): Promise<void> {
    if (error.rejection?.message == 'setOptions failed') {
      this.logger.warn("zxing/ngx-scanner 'setOptions failed' bug skip");
    } else {
      this.logger.error(error);
      // let apiJson = await this.sessionServiceService.getSession();
      // if(!isNullOrEmpty(apiJson) && !isNullOrEmpty(JSON.parse(apiJson).userProfile)){
      //   this.uuid = JSON.parse(apiJson).userProfile.uuid
      // }else{
      //   this.uuid = 'LaaS';
      // }

      // const request = {
      //   createUser: this.uuid,
      //   createDt: new Date(),
      //   updateUser: null,
      //   updateDt: null,
      //   httpStatus: 'front-end',
      //   requestBody: 'null',
      //   responseUrl: 'https://api.laasholdings.com/portal',
      //   project: 'portal',
      //   errorMessage: JSON.stringify(error.stack),
      //   errorCode: null,
      //   errorCodeCategory: 'front-end',
      // };
      // this.translateService.get('Common.Message.UnknowError').subscribe({
      //   next: (result) => {
      //     this.toastService.error(result);
      //   },
      // });
      // this.errorHandlerService.storeErrorLog(request).subscribe();
    }
  }
}
